import React from 'react'
import './dropdown.css'

const DropDown = (props) => {
    return (
        <ul onMouseEnter={props.onDropDown} onMouseLeave={props.outDropDown} className="dropdown-ul"  style={{marginLeft: props.offset, position:props.position}}>
            {props.items.map((i, index) => (
                <li key={index}><a href={i.link}>{i.name}</a></li>
            ))}
        </ul>
    )
}

export default DropDown